/**
 *
 * @author Aleynikov Boris <alynikov.boris@gmail.com>.
 */

'use strict';

var app          = require('mag-app'),
    tools        = require('./tools'),
    $title       = document.getElementById('contentTitle'),
    Intent       = require('./intent'),
    systemPlayer = require('./system.player'),
    equalizer    = require('./ui/equalizer'),
    getMenu;

function isOsdPipPresent () {

    if ( !app.config.pipSupport ) {
        return false;
    }

    // if some apps may process pip intent we should send it
    return !!core.findIntentHandlers({action: 'pip'}).length;
}


/*eslint max-lines-per-function:0*/
module.exports = function ( ) {

    if (
        app.lastPrimaryIntent &&
        app.lastPrimaryIntent.data &&
        app.lastPrimaryIntent.data.controls &&
        app.lastPrimaryIntent.data.controls.pip === false
    ) {
        // disable swap pip for intents that disable pip control button
        return;
    }

    // check if osd pip present to prevent side effects
    if ( !isOsdPipPresent() ) {
        return;
    }

    app.currentIntent.show(app.currentIntent.creator, {reasonPip: true});

    app.pipIntent = app.currentPlayIntent;
    systemPlayer.intent(new Intent({
        action: 'pip',
        mime: app.currentPlayIntent.mime,
        events: {
            maximize: function () {
                var menuElements,
                    time;

                //core.call('show');
                app.currentPlayIntent = app.pipIntent;
                app.pipIntent = null;
                app.currentIntent = app.currentPlayIntent;
                $title.innerText = app.currentPlayIntent.data.title || app.currentPlayIntent.data.uri;
                app.playback.stopProgressTimer();
                time = systemPlayer.primary.duration;
                console.log(time);
                console.log(app.currentIntent, 'app.currentIntent');
                if ( app.currentPlayIntent.mime === 'content/video') {
                    document.body.classList.add('transparent');
                    equalizer.hide();
                } else if (app.currentPlayIntent.mime === 'content/audio') {
                    document.body.classList.remove('transparent');
                    equalizer.show();
                } else {
                    equalizer.hide();
                    debug.log('player start to play without mime', 'blue');
                }
                if ( time && !(app.currentPlayIntent.data && app.currentPlayIntent.data.tvChannel) ) {

                    app.playerPanel.progressBar.show();
                    app.playerPanel.duration = time;
                    app.playerPanel.progressBar.init({
                        max: time
                    });
                    app.playback.startProgressTimer();
                    time = tools.parseTime(time);
                    app.playerPanel.$rightText.innerText = time.hour + ':' + time.min + ':' + time.sec;
                } else {
                    // app.playerPanel.$playPauseBtn.innerText = 1;
                    app.playerPanel.showPauseButton();
                    app.playerPanel.$rightText.innerText = '';
                    app.playerPanel.$leftText.innerText = '';
                    app.playerPanel.progressBar.set(0);
                    app.playerPanel.progressBar.hide();
                }
                app.playback.subtitles.list = systemPlayer.primary.subtitlesTracks;
                getMenu      = require('./menu.constructor');

                menuElements = getMenu({subtitles: app.playback.subtitles.list.length}, app.currentPlayIntent);

                app.mainMenu.init({
                    data: menuElements.data,
                    size: menuElements.data.length,
                    focusIndex: menuElements.focusIndex
                });

                // if (
                //     app.lastPrimaryIntent &&
                //     app.lastPrimaryIntent.data &&
                //     app.lastPrimaryIntent.data.tvChannel &&
                //     app.lastPrimaryIntent.data.tvChannel.archive
                // ) {
                //
                // }
                app.playerPanel.initButtons({
                    nextChannel: app.currentIntent.events.nextChannel,
                    prevChannel: app.currentIntent.events.prevChannel,
                    next: app.currentIntent.events.next,
                    prev: app.currentIntent.events.prev,
                    forward: systemPlayer.primary.duration,
                    rewind: systemPlayer.primary.duration,
                    // add play pause btn if tv archive enabled
                    play:
                    (app.currentIntent && app.currentIntent.data.tvChannel && app.currentIntent && app.currentIntent.data.tvChannel.archive)
                    || systemPlayer.primary.duration
                });

                require('./ui/spinner').hide();

                if ( systemPlayer.primary.state === systemPlayer.STATE_PAUSE ) {
                    app.playerPanel.showPlayButton();
                    if ( equalizer.active ) {
                        equalizer.pause();
                    }
                }
            },
            swap: function () {
                var time,
                    menuElements,
                    tmpIntent;

                tmpIntent = app.pipIntent;
                app.pipIntent = app.currentPlayIntent;
                app.currentPlayIntent = tmpIntent;
                //
                app.currentIntent = app.currentPlayIntent;
                $title.innerText = app.currentPlayIntent.data.title || app.currentPlayIntent.data.uri;
                app.playback.stopProgressTimer();
                time = systemPlayer.primary.duration;
                if ( app.currentPlayIntent.mime === 'content/video') {
                    document.body.classList.add('transparent');
                    if ( equalizer.active ) {
                        equalizer.hide();
                    }
                } else if (app.currentPlayIntent.mime === 'content/audio') {
                    document.body.classList.remove('transparent');
                    equalizer.show();
                } else {
                    // hmm
                }
                if ( time ) {

                    app.playback.duration = time;
                    app.playerPanel.progressBar.init({
                        max: time
                    });
                    app.playerPanel.progressBar.show();
                    app.playback.startProgressTimer();
                    time = tools.parseTime(time);
                    app.playerPanel.$rightText.innerText = time.hour + ':' + time.min + ':' + time.sec;
                } else {
                    // app.playerPanel.$playPauseBtn.innerText = 1;
                    app.playerPanel.$rightText.innerText = '';
                    app.playerPanel.$leftText.innerText = '';
                    app.playerPanel.progressBar.set(0);
                    app.playerPanel.progressBar.hide();
                }
                app.playback.subtitles.list = systemPlayer.primary.subtitlesTracks;

                getMenu      = require('./menu.constructor');

                menuElements = getMenu({subtitles: app.playback.subtitles.list.length});

                app.mainMenu.init({
                    data: menuElements.data,
                    size: menuElements.data.length,
                    focusIndex: menuElements.focusIndex
                });

                app.emit('swap');


            }
        }
    }));
    app.emit('close');
    // core.call('hide');
    app.pipIntent.emit('onPip');
};
